import debounce from "lodash/debounce";

import { useSubHeaderPropertyStore } from "@/stores/subHeaderPropertyStore/useSubHeaderPropertyStore";

export const useBaseLayoutHeight = () => {
    let debouncedCalculateHeights: ReturnType<typeof debounce> | null = null;
    const subHeaderStore = useSubHeaderPropertyStore();

    const removeResizeEventListener = () => {
        if (debouncedCalculateHeights) {
            window.removeEventListener("resize", debouncedCalculateHeights);
        }
    };

    const initializeWithElement = (element: HTMLElement) => {
        if (!element) return;

        // Remove previous listener before adding a new one to prevent memory leaks
        removeResizeEventListener();

        const calculateHeightForElement = () => {
            // Check if element is still in the DOM
            if (!element.isConnected) return;

            const elementHeight = element.offsetHeight;
            subHeaderStore.setHeight(elementHeight);
        };

        calculateHeightForElement();

        // Create a fresh debounced function for this element to avoid stale closures
        debouncedCalculateHeights = debounce(calculateHeightForElement, 20);
        window.addEventListener("resize", debouncedCalculateHeights);
    };

    const reset = () => {
        removeResizeEventListener();
        debouncedCalculateHeights = null;
    };

    return { initializeWithElement, reset };
};
